import { api } from '../lib/api'

export type AccountProfile = {
  display_name: string
  handle: string
  email: string
  avatar_url: string
  joined: string
}

export type PlanPrice = {
  amount_cents: number
  display: string
}

export type PlanSummary = {
  slug: string
  name: string
  description: string
  interval: 'monthly' | 'yearly'
  currency: string
  price: PlanPrice
  features: string[]
}

export type SubscriptionSummary = {
  status: 'active' | 'canceled' | 'past_due' | 'trialing' | 'incomplete'
  renewal_at: string | null
  started_at: string
  canceled_at: string | null
  external_reference: string
  plan: PlanSummary
}

export type WalletSummary = {
  fiat_estimate: string
  pixe_balance: string
  usd_balance: string
  ss58_address: string
  payout_ready: boolean
  connected_account: null | {
    account_id: string
    charges_enabled: boolean
    payouts_enabled: boolean
    requirements: Record<string, unknown>
  }
}

export type PaymentMethod = {
  id: number
  brand: string
  last4: string
  exp_month: number
  exp_year: number
  funding: string
  is_default: boolean
  source: string
  external_reference: string
  updated_at: string
}

export type Invoice = {
  id: number
  status: 'paid' | 'due' | 'past_due' | 'void' | 'refunded'
  amount: PlanPrice
  currency: string
  issued_at: string | null
  due_at: string | null
  external_reference: string
  plan: PlanSummary | null
}

export type AccountSummary = {
  profile: AccountProfile
  subscription: SubscriptionSummary | null
  wallet: WalletSummary
  payment_methods: PaymentMethod[]
  invoices: Invoice[]
}

export async function getAccountSummary() {
  const { data } = await api.get<AccountSummary>('/api/account/summary/')
  return data
}

export async function getPaymentMethods() {
  const { data } = await api.get<PaymentMethod[]>('/api/account/payment-methods/')
  return data
}

export async function getInvoices(params?: { status?: string; limit?: number }) {
  const { data } = await api.get<Invoice[]>('/api/account/invoices/', { params })
  return data
}
